import { initClient } from "@redwoodjs/sdk/client";

initClient();
